import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileUpload } from '../../../services/dokumente.service';

export interface ImageModalData {
  images: FileUpload[];
  currentIndex: number;
  indikatorId?: string;
  getImageUrl: (image: FileUpload) => string;
}

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit, OnDestroy {
  currentIndex: number = 0;
  images: FileUpload[] = [];
  currentImage: FileUpload | null = null;
  getImageUrl: (image: FileUpload) => string;

  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageModalData
  ) {
    this.images = data.images || [];
    this.currentIndex = data.currentIndex || 0;
    this.getImageUrl = data.getImageUrl;
    this.updateCurrentImage();
  }

  ngOnInit(): void {
    // Handle keyboard navigation
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  private handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'ArrowLeft') {
      this.previousImage();
    } else if (event.key === 'ArrowRight') {
      this.nextImage();
    } else if (event.key === 'Escape') {
      this.onClose();
    }
  }

  updateCurrentImage(): void {
    if (this.images.length > 0 && this.currentIndex >= 0 && this.currentIndex < this.images.length) {
      this.currentImage = this.images[this.currentIndex];
    } else {
      this.currentImage = null;
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.updateCurrentImage();
    }
  }

  previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCurrentImage();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  hasNext(): boolean {
    return this.currentIndex < this.images.length - 1;
  }

  hasPrevious(): boolean {
    return this.currentIndex > 0;
  }

  getImageCounter(): string {
    return `${this.currentIndex + 1} / ${this.images.length}`;
  }

  onImageError(event: Event): void {
    console.error('Error loading image in modal:', event);
    const img = event.target as HTMLImageElement;
    img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23ccc"/%3E%3Ctext x="50" y="50" text-anchor="middle" dy=".3em" fill="%23999"%3EBild nicht verfügbar%3C/text%3E%3C/svg%3E';
    img.alt = 'Bild konnte nicht geladen werden';
  }
}

